import { render, staticRenderFns } from "./ParentingOrderAgreement.vue?vue&type=template&id=70f083d9"
import script from "./ParentingOrderAgreement.vue?vue&type=script&lang=ts"
export * from "./ParentingOrderAgreement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports